import { RoomDetailsProps } from '@msc-b2c/interfaces/types';
import styles from '../stateroomdetails.module.scss';
import { Text } from '@msc-b2c/shared-components';

const RoomDetails: React.FC<RoomDetailsProps> = ({ roomDetailsTitle, roomDetails }) => {
  return (
    <>
      <div className={styles.roomDetailsTitle}>
        <Text text={roomDetailsTitle} />
      </div>
      <div className={styles.roomDetailsContent}>
        {roomDetails.map(({ label, value }) => (
          <div
            key={`${label}-${value}`}
            className={styles.roomDetailsElement}
          >
            <Text
              text={label}
              styleOption={'roomDetailsLabel'}
            />
            <Text
              text={value}
              styleOption={'roomDetailsValue'}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default RoomDetails;
